import { Button } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'components/FormControls/form-controls.module.scss'

const BackButton = ({ onGoBack, label = null, ...rest }) => {
  const { t } = useTranslation(['common'])

  const goBack = useCallback(() => {
    global.history.go(-1)
  }, [])

  return (
    <Button
      variant="ghost"
      grey
      size="l"
      type="button"
      className={styles['back-button']}
      onClick={() => (onGoBack ? onGoBack() : goBack())}
      {...rest}
    >
      {label || t('common::form_buttons.cancel')}
    </Button>
  )
}

BackButton.propTypes = {
  onGoBack: PropTypes.func,
  label: PropTypes.string,
}

export default BackButton
